import script from "./Onboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./Onboarding.vue?vue&type=script&setup=true&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=67e15612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e15612"]])

export default __exports__